// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"bfc06358","703":"7f097cb5","787":"a3c2cdac"}[chunkId] + ".chunk.js";
};